/* eslint-disable max-len */
import { FC } from 'react';
import { AllieIconProps } from '../../../components';

export const WifiOffPageIcon: FC<AllieIconProps> = ({ allieColor = 'neutral-90' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20" fill="none">
    <path
      d="M15.1186 8.00002C16.4869 8.42633 17.769 9.11911 18.8866 10.05M22.3866 6.49997C19.4641 3.92394 15.7023 2.50262 11.8066 2.50262C11.2016 2.50262 10.5998 2.5369 10.0039 2.60447M8.33643 13.61C9.35163 12.8888 10.5661 12.5013 11.8114 12.5013C13.0568 12.5013 14.2712 12.8888 15.2864 13.61M11.8066 17.5H11.8166M1 6.70076C2.33361 5.47869 3.87503 4.47975 5.56515 3.76306M4.53857 10.243C5.93598 9.01198 7.64836 8.13016 9.53929 7.73393M15.505 13.7751C14.4859 12.9763 13.2018 12.5 11.8065 12.5C10.3901 12.5 9.08836 12.9908 8.06201 13.8116M2.80664 1L20.8066 19"
      stroke={`var(--allie-color-${allieColor})`}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
